import CityPageToldos from "../components/CityPageToldos";

export default function ToldosMarbella() {
  return (
    <CityPageToldos
      name="Marbella"
      slug="marbella"
      cp="29600-29604"
      poblacion={160000}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5099}
      lng={-4.8826}
      zonas={["Puerto Banús", "Nueva Andalucía", "Las Chapas", "Elviria", "Sierra Blanca", "San Pedro"]}
      landmarks={["Puerto Banús", "Paseo Marítimo", "Sierra Blanca"]}
      municipiosLimitrofes={["Ojén", "Benahavís", "Estepona", "Mijas"]}
      festivalLocal="Feria de San Bernabé, 11 de junio"
      contextoTipologico="Villas premium con grandes pérgolas en Sierra Blanca, terrazas Puerto Banús, hostelería de lujo con toldos motorizados gran formato."
      isCoreZone={true}
    />
  );
}